import { render } from "./UserFormCard.vue?vue&type=template&id=4d39e157&ts=true"
import script from "./UserFormCard.vue?vue&type=script&lang=ts"
export * from "./UserFormCard.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/Chirbou/digithia/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__